<p-toast position="top-right" key="save"></p-toast>
<div class="fixed transform z-5" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>
<div class="fixed transform" style="z-index: 1200;" *ngIf="showsharedProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>
<!-- CASES GRID LIST -->
<ng-container *ngIf="!EditScreenBool">
  <div class="bg-default px-3 pb-3">
    <div class="flex justify-content-between align-items-center title-bg title-case" style="margin-bottom: 5px;">
      <div class="conten">
        <div class="btn"><a>Cases</a></div>
      </div>
    </div>
    <!-- First Half -->
    <div class="grid cases-screen">
      <!-- Filters -->
      <div class="col-12 md:col-6 lg:col-2">
        <label for="caseNumber"><b>Facility:</b></label>
        <p-multiSelect class="w-full" [options]="facilityList" 
        [style]="{'width':'100%', 'white-space': 'normal', 'line-height': '1.5'}" 
        [panelStyle]="{'overflow-x': 'hidden', 'word-wrap': 'break-word'}"
        placeholder="--Select Facility--" defaultLabel="--Select--" display="chip"
        [(ngModel)]="selectedFacility"
         optionLabel="Text" optionValue="Value" virtualScrollItemSize="43"
          [filter]="true" [virtualScroll]="true"
          (onChange)="getAllCases('facilityIDs', false)">
        </p-multiSelect>
      </div>
      <div *ngIf="!roleForFacility" class="col-12 md:col-6 lg:col-2">
        <label for="FirstName"><b>QPS:</b></label>
        <span class="p-input-icon-right w-full">
          <p-multiSelect class="w-full" [options]="Teleneuro_QPS" (onChange)="getAllCases('qps', false)"
            [(ngModel)]="selectedTeleneuro_QPS" [style]="{'Width':'100%'}" [panelStyle]="{'width':'100%'}"
            placeholder="Select QPS" defaultLabel="--Select--" display="chip" optionLabel="Text" optionValue="Value"
            virtualScrollItemSize="43" [filter]="true" [virtualScroll]="true">
          </p-multiSelect>
        </span>
      </div>

      <div class="col-12 md:col-6 lg:col-2">
        <label for="caseNumber"><b>Thrombolytic:</b></label>
        <p-dropdown [options]="thrombolyticsOptions" [(ngModel)]="thrombolytics"
          (onChange)="getAllCases('thrombolytics', false)" class="form-control" placeholder="--Select Thrombolytic--"
          optionLabel="name" optionValue="value">
        </p-dropdown>
      </div>
      <div *ngIf="!roleForFacility" class="col-12 md:col-6 lg:col-2">
        <label for="caseNumber"><b>QPS Review Completed:</b></label>
        <p-dropdown [options]="qpsReviewOptions" [(ngModel)]="qpsReviewCompleted"
          (onChange)="getAllCases('qpsReview', false)" class="form-control" optionLabel="name" optionValue="value">
        </p-dropdown>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <label for="caseNumber"><b>Door to Needle Time:</b></label>
        <span class="p-input-icon-right w-full">
          <p-dropdown class="w-full" [options]="doortoNeedleTimeOptions"
            (onChange)="getAllCases('doortoNeedleTime', false)" [(ngModel)]="doortoNeedleTime"
            [style]="{'Width':'100%'}" [panelStyle]="{'width':'100%'}" placeholder="--Select Needle Time--"
            defaultLabel="--Select--" optionLabel="name" optionValue="value">
          </p-dropdown>
        </span>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <label for="FirstName"><b>Audio Only:</b></label>
        <span class="p-input-icon-right w-full" id="audio_only">
          <p-dropdown [options]="audioOnlyList" (onChange)="getAllCases('audioOnly', false)" [(ngModel)]="audioOnly"
            class="form-control" placeholder="--Select--" optionValue="value" optionLabel="name">
          </p-dropdown>
        </span>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <label for="FirstName"><b>Case Status:</b></label>
        <span class="p-input-icon-right w-full">
          <p-multiSelect class="w-full" (onChange)="getAllCases('status', false)" [options]="statusList"
            placeholder="Select Status" defaultLabel="--Select--" [(ngModel)]="status" optionLabel="name" display="chip"
            optionValue="value">
          </p-multiSelect>
        </span>
      </div>
      <div  class="col-12 md:col-6 lg:col-2">
        <label for="caseNumber"><b>Case Type:</b></label>
        <p-multiSelect [options]="caseTypeOptions" [(ngModel)]="cas_case_type" (onChange)="getAllCases('caseType', false)" optionLabel="Text"
          class="form-control" placeholder="--Select Case Type--" [filter]="true" filterBy="Text" optionValue="Value"
          display="chip"></p-multiSelect>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <label for="FirstName"><b>Follow-Up:</b></label>
        <span class="p-input-icon-right w-full mt-1" id="follow_up">
          <p-dropdown [options]="folowUpList" (onChange)="getAllCases('followUp', false)" [(ngModel)]="folowUp"
            class="form-control" placeholder="--Select--" optionLabel="name" optionValue="value">
          </p-dropdown>
        </span>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <label for="FirstName"><b>Time Frame:</b></label>
        <span class="p-input-icon-right w-full mt-1" id="frame_up">
          <p-dropdown [options]="timeFameList" (onChange)="onChangeTimeFrame($event)" [(ngModel)]="timeFrame"
            class="form-control" optionLabel="name" optionValue="value">
          </p-dropdown>
        </span>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <label for="FirstName"><b>Flag:</b></label>
        <span class="p-input-icon-right w-full">
          <p-dropdown [options]="casIsFlaggedList" (onChange)="getAllCases('flag', false)" [(ngModel)]="casIsFlagged"
            class="form-control" placeholder="--Select--" optionValue="value" optionLabel="name">
          </p-dropdown>
        </span>
      </div>
      <div class="col-12 md:col-6 lg:col-2" *ngIf="showDateBool == true">
        <label for="FirstName"><b
            [ngStyle]="specificDatecolorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">Date:</b></label>
        <p-calendar [(ngModel)]="txtSpecificDate" [minDate]="minDate" [showIcon]="true" inputId="icon" class="mr-2">
        </p-calendar>
      </div>
      <div class="col-12 md:col-6 lg:col-2" *ngIf="showStartEndDateBool == true">
        <label for="FirstName"><b
            [ngStyle]="textStrtColorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">Start
            Date:</b></label>
        <p-calendar [(ngModel)]="txtStartDate" [minDate]="minDate" [showIcon]="true" inputId="icon" class="mr-2">
        </p-calendar>
      </div>
      <div class="col-12 md:col-6 lg:col-2" *ngIf="showStartEndDateBool == true">
        <label for="FirstName"><b
            [ngStyle]="textEndColorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">End
            Date:</b></label>
        <p-calendar [(ngModel)]="txtEndDate" [showIcon]="true" inputId="icon" class="mr-2">
        </p-calendar>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <label for="FirstName"><b>Keyword Search:</b></label>
        <span class="p-input-icon-left w-full mt-1" id="keyword_search">
          <i class="pi pi-search"></i>
          <input pInputText type="text" [(ngModel)]="searchField" (input)="applyFilterGlobal($event, 'contains')"
            placeholder="Search Cases..." id="keyword_search_child" />
            <i class="pi pi-times case-keywordsearch" *ngIf="crossSearchBool" (click)="clearSearchField()"></i>
        </span>
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12" id="search_btn">
        <p-button label="Export to Excel" icon="pi pi-upload" (click)="exportExcel()" [loading]="exportExcelLoader"
          class="p-button-primary mr-2 export-largescreen"></p-button>
        <p-button icon="pi pi-file-excel" (click)="exportExcel()" [loading]="exportExcelLoader"
          class="p-button-primary mr-2 export-smartscreen"></p-button>

        <p-button *ngIf="!roleForFacility" label="Advanced" (click)="advanceSearchModal = true" (onClick)="AdvanceSearch()"
          class="p-button-primary mr-2"><i class="pi pi-search-plus mr-2"></i></p-button>

        <p-button label="Search" icon="pi pi-search" [loading]="loading[0]" (click)="getAllCases('search-btn', false)"
          (onClick)="load(0)" class="p-button-primary mr-2"></p-button>
        <p-button *ngIf="clearSearchBool" label="Clear Search" icon="pi pi-times" (click)="ClearSearch()"
          class="p-button-primary"></p-button>
      </div>
    </div>
    <div class="casesGrid mt-2">
      <p-table #dt [value]="cases" [rows]="rows" styleClass="p-datatable-striped p-datatable-gridlines createRoles"
        [paginator]="true" sortMode="multiple" [lazy]="true" (onLazyLoad)="lazyLoadSchedules($event)"
        responsiveLayout="scroll" [rowHover]="true" dataKey="Id" [totalRecords]="totalRecords" [columns]="cols"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [resetPageOnSort]="false"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25,50,totalRecords]" [resizableColumns]="true"
        columnResizeMode="expand" [globalFilterFields]="['StartTime','Type','PatientName','CaseNumber','CaseStatus']">
        <ng-template pTemplate="header">
          <tr>
            <th>Action </th>
            <th pSortableColumn="CaseNumber" pResizableColumn>Case No.
              <p-sortIcon field="CaseNumber"></p-sortIcon>
            </th>
            <th pSortableColumn="AudioOnly" pResizableColumn>Audio Only
              <p-sortIcon field="AudioOnly"></p-sortIcon>
            </th>
            <th pSortableColumn="PatientID" pResizableColumn>Patient ID
              <p-sortIcon field="PatientID"></p-sortIcon>
            </th>
            <th pSortableColumn="FacilityName">Facility
              <p-sortIcon field="FacilityName"></p-sortIcon>
            </th>
            <th pSortableColumn="PatientDOB">Patient DOB
              <p-sortIcon field="PatientDOB"></p-sortIcon>
            </th>
            <th pSortableColumn="LyticCandidate">Lytic Candidate
              <p-sortIcon field="LyticCandidate"></p-sortIcon>
            </th>
            <th pSortableColumn="Type">Type
              <p-sortIcon field="Type"></p-sortIcon>
            </th>
            <th pSortableColumn="PhysicianName">Physician
              <p-sortIcon field="PhysicianName"></p-sortIcon>
            </th>
            <th *ngIf="!roleForFacility" pSortableColumn="CaseStatus">Case Status
              <p-sortIcon field="CaseStatus"></p-sortIcon>
            </th>
            <th *ngIf="!roleForFacility" pSortableColumn="QPSReviewCompleted">QPS Review Completed
              <p-sortIcon field="QPSReviewCompleted"></p-sortIcon>
            </th>
            <th pSortableColumn="StartTime">Start Time
              <p-sortIcon field="StartTime"></p-sortIcon>
            </th>
            <th pSortableColumn="PatientName">Patient Name
              <p-sortIcon field="PatientName"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <h5 *ngIf="totalRecords==0" class="text-center create-roles">
              <b> No records found</b></h5>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-cases>
          <tr>
            <td>
              <span class="no-underline flex">
                <a class="no-underline" (contextmenu)="onContextMenu($event,cases,'Edit')">
                  <button *ngIf="isAccessReadWrite && !roleForFacility && (cases.CaseType == 'Stroke Alert' || cases.CaseType == 'STAT Consult')" pButton pRipple icon="pi pi-pencil" pTooltip="Edit Case Review"
                    tooltipPosition="left" class="p-button-rounded  p-button-primary mr-2"
                    (click)="getCaseDetailByCaseId(cases); onContextMenuPreventDefault($event)"></button>
                </a>
                <a class="no-underline flex" (contextmenu)="onContextMenu($event,cases,'View')">
                  <button *ngIf="(isAccessReadWrite || isAccessRead) && (cases.CaseType == 'Stroke Alert' || cases.CaseType == 'STAT Consult')" pButton pRipple icon="pi pi-eye"
                    pTooltip="View Case Review" tooltipPosition="bottom" class="p-button-rounded  p-button-primary mr-2"
                    (click)="Viewcasereview(cases); onContextMenuPreventDefault($event)"></button>
                </a>
                <button *ngIf="(isAccessReadWrite || isAccessRead) && !roleForFacility" pButton pRipple icon="pi pi-arrow-up-right"
                  pTooltip="View case" tooltipPosition="right" class="p-button-rounded  p-button-primary mr-2"
                  (click)="Accesscase(cases)"></button>

              </span>

            </td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.CASENumber}}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)"><img *ngIf="cases.cas_is_audio_consult" src="../../../../../../assets/images/microphone.png" width="20px"></td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.CASEIdentificatinNumber}}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.FacilityName}}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.PatientDOB | date:'MM/dd/yyyy'}}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.cas_metric_tpa_consult == true ? 'Yes' : 'No'}}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.CaseType}}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.PhysicianName}}</td>
            <td *ngIf="!roleForFacility" [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.caseStatusLabel}}</td>
            <td *ngIf="!roleForFacility" [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{(cases.caseStatusLabel === 'Stroke Alert' || cases.caseStatusLabel === 'Stroke Alert') && cases.QPSReviewCompleted == 1 ? 'Yes' : ''}}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.CaseStartTime | date:'MM/dd/yyyy H:mm:ss' }}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" tooltipPosition="left" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.PatientName}}</td>
          </tr>
        </ng-template>
      </p-table>
      <div class="md:col-12">
        <span class="tableRefreshTime">
          Grid Last Refreshed at {{analyzeService._currentDate}} - {{analyzeService._currentTime}}
        </span>
      </div>
    </div>
  </div>
</ng-container>

<!-- CASES Edit Screen -->
<ng-container *ngIf="EditScreenBool">
  <div class="content-height bg-default px-3 pb-3">

    <div class="flex justify-content-between align-items-center title-bg titlebg-fixed title-case">
      <div class="backbtn-analyze -ml-3   cursor-pointer" (click)="backTocasesList('backTocasesList');" pTooltip="Back"
        tooltipPosition="right">
        <i class="pi pi-arrow-left"></i>
      </div>
      <div class="conten">
        <div class="btn"><a>{{caseHeaderName}}</a></div>
      </div>
      <div class="-ml-4">
        <span class="open-telecase">
          <button *ngIf="!roleForFacility" pButton pRipple type="button" (click)="Accesscase('')" label="OPEN CASE IN TELECARE"
            class="p-button-raised p-button-text p-button-plain"></button>
        </span>
      </div>
    </div>
    <div class="col-12">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-6">
          <div class="cards">
            <article class="information [ case-card ]">
              <dl class="details">
                <div>
                  <dt><span class="name-dt">Facility:</span> <span
                      class="dt-text">{{SelectedCaseEdit[0].FacilityName}}</span></dt>
                </div>
                <div>
                  <dt><span class="name-dt">Patient DOB:</span> <span
                      class="dt-text">{{SelectedCaseEdit[0].PatientDOB | date:'MM/dd/yyyy'}}</span></dt>
                </div>

              </dl>
              <dl class="details">
                <div>
                  <dt><span class="name-dt">Patient Name:</span> <span
                      class="dt-text">{{SelectedCaseEdit[0].PatientName}}</span></dt>
                </div>
                <div>
                  <dt><span class="name-dt">Start Time:</span> <span
                      class="dt-text">{{SelectedCaseEdit[0].CaseStartTime | date:'MM/dd/yyyy H:mm:ss' }}</span></dt>
                </div>
                <!-- <div>
                  <dt><span class="name-dt">QPS Review Completed:</span> <span class="dt-text">{{SelectedCaseEdit[0].QPSReviewCompleted == 1?'Yes':''}}</span></dt>
                </div> -->
              </dl>
            </article>
          </div>
        </div>
        <div class="col-12 md:col-12 lg:col-6">
          <div class="cards">
            <article class="information [ case-card ]">
              <dl class="details">
                <div>
                  <dt><span class="name-dt">Physician:</span> <span
                      class="dt-text">{{SelectedCaseEdit[0].PhysicianName}}</span></dt>
                </div>
                <div>
                  <dt><span class="name-dt">Case No:</span> <span
                      class="dt-text">{{SelectedCaseEdit[0].CASENumber}}</span></dt>
                </div>
              </dl>
              <dl class="details">
                <div>
                  <dt><span class="name-dt">Case Type:</span> <span
                      class="dt-text">{{SelectedCaseEdit[0].CaseType}}</span></dt>
                </div>
                <div>
                  <dt><span class="name-dt">Patient Identifier:</span> <span
                      class="dt-text">{{SelectedCaseEdit[0].CASEIdentificationTYPE}}</span></dt>
                </div>
              </dl>
            </article>
          </div>
        </div>
      </div>
      <form [formGroup]="form" (ngSubmit)="submit('save')">
        <div class="grid cases-screen">
          <!-- First Half -->
          <div class="col-12 md:col-12 lg:col-6">
            <div class="rpi-metrics col-12 md:col-12 lg:col-12">
              <label class="text-white mb-0"><b>Consult Information</b></label>
            </div>
            <div class="col-6 mt-3 field-checkbox">
              <!-- <p-checkbox formControlName="cas_is_audio_consult" [binary]="true"
                inputId="audio"></p-checkbox> -->
                <p-checkbox class="pointer-event" formControlName="cas_is_audio_consult" [readonly]="true" [binary]="true" value="cas_is_audio" inputId="ny"></p-checkbox>
              <label for="audio"><b>AUDIO ONLY CONSULT</b></label>
            </div>
            <div class="grid">
              <div class="col-12 md:col-12 lg:col-6 mt-3" [ngClass]="{'disabled':isReadonly || isReadonlyUnCancleCase}">
                <label for="DateofConsult"><b>Date of Consult:</b></label>
                <span class="p-input-icon-right w-full">
                  <p-calendar [showIcon]="true" inputId="icon" formControlName="cas_billing_date_of_consult"
                    [readonlyInput]="true">
                  </p-calendar>
                </span>
              </div>
              <div class="col-12 md:col-12 lg:col-6 mt-3">
              <div  
                [ngClass]="{'disabled':isReadonlyUnCancleCase}">
                <label class="mr-1" for="Physician"><b>Physician:</b>&nbsp;<span class="mr-3">{{PhysicianName}}</span></label><br>
                <span *ngIf="isAccessPhysicionHistory && !roleForFacility"  class="popUp-Text" (click)="caseAssignmentHistoryDialog();"><b>History</b></span>
                <!-- <div class="mt-1">
                  <span class="mr-3">{{PhysicianName}}</span>

                </div> -->
              </div>
            </div>
              <div class="col-12 md:col-12 lg:col-6">
                <label style="color: #800020 !important;" class="mr-3" for="WorkflowType"><b>Workflow Type:</b></label>
                <b>{{workFlowType}}</b>
              </div>
              <div class="col-12 md:col-12 lg:col-6">
                <label for="Ealert" class="mr-3"><b>E alert:</b></label>
                <span>{{Ealert}}</span>
              </div>

              <div class="col-12 md:col-12 lg:col-6" *ngIf="!editCaseData.cas_is_audio_consult">
                <label for="TFLAtoNIHSSStartAssessmentTime"><b>Symptoms:</b></label>
                <span class="p-input-icon-right w-full">
                  <textarea formControlName="cas_metric_symptoms" rows="3" cols="30" [readonly]="true" class="pointer-event" pInputTextarea></textarea>
                </span>
              </div>
              <div class="col-12 md:col-12 lg:col-6" *ngIf="!editCaseData.cas_is_audio_consult">
                <label for="MedicalDirectortoReview"><b>Lytic Status:</b></label>
              <span class="pointer-event" class="p-input-icon-right w-full mt-2">
                <p-radioButton id="Yes" [value]="true" formControlName="cas_metric_tpa_consult" class="pointer-event"></p-radioButton>
                <label class="-mb-3 ml-1 mr-3" for="Yes">Yes</label>
                <p-radioButton id="No" [value]="false" formControlName="cas_metric_tpa_consult" class="pointer-event"></p-radioButton>
                <label class="-mb-3 ml-1" for="No">No</label>
              </span>
              </div>

              <div class="col-12 md:col-12 lg:col-6">
                <div>
                  <label for="LastKnownWell"><b>Last Known Well:</b></label>
                  <span class="p-input-icon-right">
                    <input id="disabled-input" name="cas_metric_lastwell_date_est" type="text"
                      class="inputfield pointer-event" pInputText formControlName="cas_metric_lastwell_date_est">
                  </span>
                </div>
                <div class="mt-2">
                  <label for="ArrivalTime"><b>Arrival Time (if available):</b></label>
                  <span class="p-input-icon-right">
                    <p-calendar formControlName="cas_metric_door_time_est" [showTime]="true" [showSeconds]="true"
                      inputId="time" class="pointer-event" [readonlyInput]="true">
                    </p-calendar>
                  </span>
                </div>
                <div *ngIf="!roleForFacility"class="mt-2 Initial-none">
                  <label for="InitialresponseTime"><b>Initial Response Time:</b></label>
                  <span class="p-input-icon-right">
                    <p-calendar formControlName="cas_metric_initial_response_time_est" [showTime]="true"
                      [showSeconds]="true" inputId="time" class="pointer-event" [readonlyInput]="true">
                    </p-calendar>
                  </span>
                </div>
                <div *ngIf="!roleForFacility"class="mt-2 stamp-none">
                  <label for="StampTime"><b>Stamp Time:</b></label>
                  <span class="p-input-icon-right">
                    <p-calendar formControlName="cas_metric_stamp_time_est" [showTime]="true" [showSeconds]="true"
                      inputId="time" class="pointer-event" [readonlyInput]="true">
                    </p-calendar>
                  </span>
                </div>
                <div class="mt-2">
                  <label for="AssessmentTime"><b>Assessment Time:</b></label>
                  <span class="p-input-icon-right">
                    <input formControlName="cas_assessment_time_est" pInputText type="text" inputId="time"
                      class="pointer-event">
                  </span>
                </div>
              </div>
              <div *ngIf="!roleForFacility" class="col-12 md:col-12 lg:col-6">
                <label for="TFLAtoNIHSSStartAssessmentTime"><b>Thrombolytic Delay Notes:</b></label>
                <span class="p-input-icon-right w-full">
                  <textarea formControlName="cas_billing_tpa_delay_notes" rows="14" cols="30" [readonly]="isReadonly || isReadonlyUnCancleCase"  pInputTextarea></textarea>
                </span>
              </div>
              <div *ngIf="roleForFacility"class="col-12 md:col-12 lg:col-6 ">
                <label for="InitialresponseTime"><b>Initial Response Time:</b></label>
                <span class="p-input-icon-right">
                  <p-calendar formControlName="cas_metric_initial_response_time_est" [showTime]="true"
                    [showSeconds]="true" inputId="time" class="pointer-event" [readonlyInput]="true">
                  </p-calendar>
                </span>
                <div class="mt-2 ">
                  <label for="StampTime"><b>Stamp Time:</b></label>
                  <span class="p-input-icon-right">
                    <p-calendar formControlName="cas_metric_stamp_time_est" [showTime]="true" [showSeconds]="true"
                      inputId="time" class="pointer-event" [readonlyInput]="true">
                    </p-calendar>
                  </span>
                </div>
              </div>
              
              <ng-container *ngIf="thrombolyticCandidateBool">
                <div class="col-12 md:col-12 lg:col-6">
                  <label for="TFLAtoNIHSSStartAssessmentTime"><b>Start Time to Needle Time:(< 40 Minutes):</b> </label>
                        <span class="p-input-icon-right w-full">
                        <input [ngClass]="StartTimetoNeedleTimeLessThen40MinutesBool == true ? 'rapidiNo' : 'rapidi'"
                          id="LastName" name="LastName" type="text" class="inputfield pointer-event" pInputText
                          formControlName="StartTimetoNeedleTimeLessThen40Minutes">
                        </span>
                </div>
                <!-- <div class="md:col-6">
                  <label for="TFLAtoNIHSSStartAssessmentTime"><b>TFLA to Needle Time:(< 30 Minutes):</b></label> <span
                      class="p-input-icon-right w-full">
                      <input [ngClass]="TFLAtoNeedleTimelessThen30MinutesBool == true ? 'rapidiNo' : 'rapidi'"
                        id="LastName" name="LastName" type="text" class="inputfield pointer-event" pInputText
                        formControlName="TFLAtoNeedleTimelessThen30Minutes">
                      </span>
                </div> -->
              </ng-container>
              <div *ngIf="isAccessTFLA && !roleForFacility" class="col-12 md:col-12 lg:col-6">
                <label (click)="timeFirstLoginAttemptDialog();" for="TFLA" class="popUp-Text"><b>TFLA</b></label>
              </div>
              <!--  <div class="md:col-6">
                <label for="TFLAtoNIHSSStartAssessmentTime"><b>TFLA to NIHSS Start Assessment Time:(< 10 minutes):</b></label>
                    <span class="p-input-icon-right w-full">
                    <input [ngClass]="firstTimeLoginAttemtToNIHSSassTimeBool == true ? 'rapidiNo' : 'rapidi'"
                      id="LastName" name="LastName" type="text" class="inputfield pointer-event" pInputText
                      formControlName="firstTimeLoginAttemtToNIHSSassTime">
                    </span>
              </div> -->

              <ng-container *ngIf="thrombolyticCandidateBool">
                <div class="col-12 md:col-12 lg:col-6">
                  <label for="TFLAtoNIHSSStartAssessmentTime"><b>{{ArrivalToNeedleTimeLable}}</b></label>
                  <span class="p-input-icon-right w-full">
                    <input [ngClass]="ArrivalToNeedleTimeBool == true ? 'rapidiNo' : 'rapidi'" id="LastName"
                      name="LastName" type="text" class="inputfield pointer-event" pInputText
                      formControlName="ArrivalToNeedleTime">
                  </span>
                </div>
              </ng-container>





              <ng-container *ngIf="thrombolyticCandidateBool">
                <div class="md:col-6" [ngClass]="{'disabled':isReadonly}">
                  <label for="TFLAtoNIHSSStartAssessmentTime"><b>Thrombolytic-related Complication:</b></label>
                  <span class="p-input-icon-right w-full">
                    <p-radioButton id="Yes" class="ml-3" [value]=1 formControlName="cas_response_thrombolytic"
                      (click)="thrombolyticRelatedComplication('Yes');">
                    </p-radioButton>
                    <label class="-mb-3 ml-1 mr-3" for="Yes">Yes</label>
                    <p-radioButton id="No" [value]=2 formControlName="cas_response_thrombolytic"
                      (click)="thrombolyticRelatedComplication('No');">
                    </p-radioButton>
                    <label class="-mb-3 ml-1" for="No">No</label>
                  </span>
                </div>
                <div class="md:col-6" *ngIf="thrombolyticComplicationBool">
                  <span class="p-input-icon-right w-full">
                    <p-dropdown [options]="thrombolyticComplicationDropdown"
                      formControlName="cas_response_thrombolytic_review" class="form-control"
                      placeholder="Select Thrombolytic-related Complication" optionLabel="name" optionValue="value"
                      [showClear]="true">
                    </p-dropdown>
                  </span>
                </div>
              </ng-container>
              <div class="rpi-metrics field md:col-12">
                <label for="RAPIDIIntervalMetrics" class="text-white mb-0"><b>RAPIDi Interval Metrics</b></label>
              </div>
              <div class="col-12 md:col-12 lg:col-6">
                <label for="ActivationTimeIntervalMetric"><b>Activation Time Interval Metric:</b></label>
                <span class="p-input-icon-right w-full">
                  <input [ngClass]="ActivationTimeIntervalMetricBool ? 'rapidi' : 'rapidiNo'" id="LastName"
                    name="LastName" type="text" class="inputfield tom pointer-event" pInputText
                    formControlName="ActivationTimeIntervalMetric">
                </span>
              </div>
              <div class="col-12 md:col-12 lg:col-6">
                <label for="ThrombolyticMedicalDecision"><b>Thrombolytic Medical Decision Time:</b></label>
                <span class="p-input-icon-right w-full">
                  <input formControlName="cas_metric_alteplase_medical_decision" pInputText inputId="time"
                    class="pointer-event">
                </span>
              </div>

              <div class="col-12 md:col-12 lg:col-6">
                <label for="AssessmentTimeIntervalMetric"><b>Assessment Time Interval Metric:</b></label>
                <span class="p-input-icon-right w-full">
                  <input [ngClass]="AssessmentTimeIntervalMetricBool ? 'rapidi' : 'rapidiNo'" id="LastName"
                    name="LastName" type="text" class="inputfield pointer-event" pInputText
                    formControlName="AssessmentTimeIntervalMetric">
                </span>
              </div>
              <div class="col-12 md:col-12 lg:col-6">
                <label for="NeedleTime"><b>Needle Time:</b></label>
                <span class="p-input-icon-right w-full">
                  <p-calendar formControlName="cas_metric_needle_time_est" [showTime]="true" [showSeconds]="true"
                    inputId="time" class="pointer-event" [readonlyInput]="true">
                  </p-calendar>
                </span>
              </div>

              <br style="width:100%">
              <div class="col-12 md:col-12 lg:col-6">
                <label for="hrombolyticDecisionIntervalMetric"><b>Thrombolytic Decision Interval Metric:</b></label>
                <span class="p-input-icon-right w-full">
                  <input [ngClass]="ThrombolyticDecisionIntervalMetricBool ? 'rapidi' : 'rapidiNo'"
                    id="LastName" name="LastName" type="text" class="inputfield tom pointer-event" pInputText
                    formControlName="ThrombolyticDecisionIntervalMetric">
                </span>
              </div>
              <div class="col-12 md:col-12 lg:col-6">
                <label for="radio2"><b>LVO:</b></label>
                  <span class="flex mt-2">
                  <p-radioButton id="Yes" class="pointer-event" [value]=1 formControlName="ctai_lvo">
                  </p-radioButton>
                  <label class="-mb-3 ml-1 mr-3 mt-1" for="IsEEG">Yes</label>
                  <p-radioButton id="No" [value]=0 formControlName="ctai_lvo" class="pointer-event">
                  </p-radioButton>
                  <label class="-mb-3 ml-1 mt-1" for="radio2">No</label>
                </span>
              </div>

              <div class="col-12 md:col-12 lg:col-6">
                <label for="ThrombolyticAdministrationIntervalMetric"><b>Thrombolytic Administration Interval
                    Metric:</b></label>
                <span class="p-input-icon-right w-full">
                  <input [ngClass]="ThrombolyticAdministrationIntervalMetricBool ? 'rapidi' : 'rapidiNo'"
                    id="LastName" name="LastName" type="text" class="inputfield pointer-event" pInputText
                    formControlName="ThrombolyticAdministrationIntervalMetric">
                </span>
              </div>
              <div class="col-12 md:col-12 lg:col-6 mt-5">
                <label for="ThrombolyticUsed" class="mr-3"><b>Thrombolytic Used:</b></label>
                <span>{{thrombolytic_used}}</span>
              </div>
              <div class="md:col-6"></div>
              <div class="col-12 md:col-12 lg:col-6">
                <label for="Pre-morbidMRS" class="mr-3"><b>Pre-morbid MRS:</b></label>
                <span>{{editCaseData.cas_metric_has_morbid_symptoms == 7 ? "Unable to assess" : editCaseData.cas_metric_has_morbid_symptoms}}</span>
              </div>
              <div class="md:col-6"></div>
              <div class="col-12 md:col-12 lg:col-6">
                <label for="radio2"><b>Discussed with NIR:</b></label>
                <span class="flex mt-2">
                  <p-radioButton id="Yes" class="pointer-event" [value]=1 formControlName="ctai_discussed_with_nir">
                  </p-radioButton>
                  <label class="-mb-3 ml-1 mr-3 mt-1" for="IsEEG">Yes</label>
                  <p-radioButton id="No" [value]=0 formControlName="ctai_discussed_with_nir" class="pointer-event">
                  </p-radioButton>
                  <label class="-mb-3 ml-1 mt-1" for="radio2">No</label>
                </span>
              </div>
              <div class="md:col-6"></div>
              <div class="col-12 md:col-12 lg:col-6">
                <label for="Discussed with NIR time"><b>Discussed with NIR time:</b></label>
                <span class="p-input-icon-right w-full">
                  <input formControlName="ctai_nir_discussion_time" pInputText inputId="time" class="pointer-event">
                </span>
              </div>
              <div class="md:col-6"></div>
              <div class="col-12 md:col-12 lg:col-6">
                <label for="Discussed with NIR time"><b>Initial Response time to Discussed with NIR time:</b></label>
                <span class="p-input-icon-right w-full">
                  <input formControlName="initial_response_time_to_Discussed_with_NIR_time" pInputText inputId="time"
                    class="pointer-event">
                </span>
              </div>
            </div>

          </div>
          <!-- Second Half -->
          <div class="col-12 md:col-12 lg:col-6">
            <p-panel *ngIf="isAccessLeaderShipReview && !roleForFacility" header="LeaderShip Review" [toggleable]="true" [collapsed]="true">
              <div class="formgrid grid"></div>
              <div [ngClass]="{'disabled':isReadonly}" class="formgrid grid">
                <div class="col-12 md:col-12 lg:col-6">
                  <label for="LeaderReviewing"><b>Leader Reviewer :</b></label>
                  <span class="p-input-icon-right w-full">
                    <p-multiSelect class="w-full" [options]="leaderReviewingDropdown" placeholder="Select User Roles"
                      defaultLabel="Select Leader Review" optionLabel="FullName" display="chip" optionValue="Id"
                      [(ngModel)]="leaderReviewingObject.clr_qps_key" [ngModelOptions]="{standalone: true}">
                    </p-multiSelect>
                  </span>
                </div>
                <div class="col-12 md:col-12 lg:col-6">
                  <label for="Date"><b>Date:</b></label>
                  <span class="p-input-icon-right w-full">
                    <p-calendar [showIcon]="true" inputId="icon" placeholder="Select Date"
                      [(ngModel)]="leaderReviewingObject.clr_date_selected" [ngModelOptions]="{standalone: true}"
                      [readonlyInput]="true">
                    </p-calendar>
                  </span>
                </div>
              </div>
              <div class="grid" [ngClass]="{'disabled':isReadonly}">
                <div class="col-12 md:col-12 lg:col-8 mt-2">
                  <label for="radio2"><b>Email Sent in 48 hrs:</b></label>
                </div>
                <div class="col-12 md:col-12 lg:col-4 mt-2">
                  <p-radioButton class="ml-3" [value]=1 [(ngModel)]="leaderReviewingObject.clr_is_email_sent"
                    name="leaderReviewingObject.clr_is_email_sent" [ngModelOptions]="{standalone: true}">
                  </p-radioButton>
                  <label class="-mb-3 ml-1 mr-3" for="IsEEG">Yes</label>
                  <p-radioButton [value]=2 [(ngModel)]="leaderReviewingObject.clr_is_email_sent"
                    name="leaderReviewingObject.clr_is_email_sent" [ngModelOptions]="{standalone: true}">
                  </p-radioButton>
                  <label class="-mb-3 ml-1" for="radio2">No</label>
                </div>
                <div class="col-12 md:col-12 lg:col-8">
                  <label for="radio2"><b>RCA completed in 8 business days:</b></label>
                </div>
                <div class="col-12 md:col-12 lg:col-4">
                  <p-radioButton class="ml-3" [value]=1 [(ngModel)]="leaderReviewingObject.clr_is_rca_completed"
                    name="leaderReviewingObject.clr_is_rca_completed" [ngModelOptions]="{standalone: true}">
                  </p-radioButton>
                  <label class="-mb-3 ml-1 mr-3" for="IsEEG">Yes</label>
                  <p-radioButton [value]=2 [(ngModel)]="leaderReviewingObject.clr_is_rca_completed"
                    name="leaderReviewingObject.clr_is_rca_completed" [ngModelOptions]="{standalone: true}">
                  </p-radioButton>
                  <label class="-mb-3 ml-1" for="radio2">No</label>
                </div>
                <div class="col-12 md:col-12 lg:col-8">
                  <label for="radio2"><b>Tertiary root cause identified:</b></label>
                </div>
                <div class="col-12 md:col-12 lg:col-4">
                  <p-radioButton class="ml-3" [value]=1
                    [(ngModel)]="leaderReviewingObject.clr_is_tertiary_rootcause_identified"
                    name="leaderReviewingObject.clr_is_tertiary_rootcause_identified"
                    [ngModelOptions]="{standalone: true}">
                  </p-radioButton>
                  <label class="-mb-3 ml-1 mr-3" for="IsEEG">Yes</label>
                  <p-radioButton [value]=2 [(ngModel)]="leaderReviewingObject.clr_is_tertiary_rootcause_identified"
                    name="leaderReviewingObject.clr_is_tertiary_rootcause_identified"
                    [ngModelOptions]="{standalone: true}">
                  </p-radioButton>
                  <label class="-mb-3 ml-1" for="radio2">No</label>
                </div>
                <div class="col-12 md:col-12 lg:col-8">
                  <label for="radio2"><b>All outliers addressed:</b></label>
                </div>
                <div class="col-12 md:col-12 lg:col-4">
                  <p-radioButton class="ml-3" [value]=1
                    [(ngModel)]="leaderReviewingObject.clr_is_all_outliers_addressed"
                    name="leaderReviewingObject.clr_is_all_outliers_addressed" [ngModelOptions]="{standalone: true}">
                  </p-radioButton>
                  <label class="-mb-3 ml-1 mr-3" for="IsEEG">Yes</label>
                  <p-radioButton [value]=2 [(ngModel)]="leaderReviewingObject.clr_is_all_outliers_addressed"
                    name="leaderReviewingObject.clr_is_all_outliers_addressed" [ngModelOptions]="{standalone: true}">
                  </p-radioButton>
                  <label class="-mb-3 ml-1" for="radio2">No</label>
                </div>
                <div class="col-12 md:col-12 lg:col-8">
                  <label for="radio2"><b>Assessment statement clear, includes cause and effect:</b></label>
                </div>
                <div class="col-12 md:col-12 lg:col-4">
                  <p-radioButton class="ml-3" [value]=1
                    [(ngModel)]="leaderReviewingObject.clr_is_assessment_statement_affect"
                    name="leaderReviewingObject.clr_is_assessment_statement_affect"
                    [ngModelOptions]="{standalone: true}">
                  </p-radioButton>
                  <label class="-mb-3 ml-1 mr-3" for="IsEEG">Yes</label>
                  <p-radioButton [value]=2 [(ngModel)]="leaderReviewingObject.clr_is_assessment_statement_affect"
                    name="leaderReviewingObject.clr_is_assessment_statement_affect"
                    [ngModelOptions]="{standalone: true}">
                  </p-radioButton>
                  <label class="-mb-3 ml-1" for="radio2">No</label>
                </div>
                <div class="col-12 md:col-12 lg:col-8">
                  <label for="radio2"><b>Free of Errors:</b></label>
                </div>
                <div class="col-12 md:col-12 lg:col-4">
                  <p-radioButton class="ml-3" [value]=1 [(ngModel)]="leaderReviewingObject.clr_free_of_errors"
                    name="leaderReviewingObject.clr_free_of_errors" [ngModelOptions]="{standalone: true}">
                  </p-radioButton>
                  <label class="-mb-3 ml-1 mr-3" for="IsEEG">Yes</label>
                  <p-radioButton [value]=2 [(ngModel)]="leaderReviewingObject.clr_free_of_errors"
                    name="leaderReviewingObject.clr_free_of_errors" [ngModelOptions]="{standalone: true}">
                  </p-radioButton>
                  <label class="-mb-3 ml-1" for="radio2">No</label>
                </div>
                <div class="col-12 md:col-12 lg:col-8">
                  <label for="radio2"><b>Countermeasure Appropriate and attainable:</b></label>
                </div>
                <div class="col-12 md:col-12 lg:col-4">
                  <p-radioButton class="ml-3" [value]=1
                    [(ngModel)]="leaderReviewingObject.clr_countermeasure_appropriate"
                    name="leaderReviewingObject.clr_countermeasure_appropriate" [ngModelOptions]="{standalone: true}">
                  </p-radioButton>
                  <label class="-mb-3 ml-1 mr-3" for="IsEEG">Yes</label>
                  <p-radioButton [value]=2 [(ngModel)]="leaderReviewingObject.clr_countermeasure_appropriate"
                    name="leaderReviewingObject.clr_countermeasure_appropriate" [ngModelOptions]="{standalone: true}">
                  </p-radioButton>
                  <label class="-mb-3 ml-1" for="radio2">No</label>
                </div>
              </div>
              <div class="flex justify-content-end">
              <p-button *ngIf="!isReadonly" label="Save" icon="pi pi-save"
                class="p-button-primary btn-padding-custom flex justify-content-end" type="button"
                (click)="saveCaseLeadershipReview();"></p-button>
              </div>
            </p-panel>
            <div class="mt-1">
            <p-panel header="NIHSS Stroke Scale/Score" [toggleable]="true" [collapsed]="true" *ngIf="!editCaseData.cas_is_audio_consult">
              <div class="col-8  field-checkbox">
                <p-checkbox formControlName="cas_nihss_cannot_completed" [readonly]="true" [binary]="true" inputId="binary" class="pointer-event"></p-checkbox>
                <label class="font-bold" style="font-size: 15px;" for="binary">NIHSS may not be reliable due to</label>
              </div>
              <div *ngIf="cas_nihss_cannot_completedBool" class="col-8">
                <p-dropdown [options]="cas_nihss_reasonOptions" formControlName="cas_NIHSS_comatose"
                 class="form-control pointer-event" placeholder="--Select--"
                optionLabel="name" optionValue="value" [readonly]="true">
              </p-dropdown>
              </div>
              <div *ngIf="cas_nihss_cannot_completedBool && cas_nihss_reasonBool" class="col-8">
                <span class="p-input-icon-right w-full">
                  <textarea formControlName="cas_NIHSS_comatose_text" [readonly]="true" rows="6" cols="30" [readonly]="true" role="button" class="pointer" pInputTextarea></textarea>
                </span>
              </div>
              <div class="col-8 ml-1">
                <span class="p-input-icon-right w-full">NIHSS Stroke Scale/Score:&nbsp;&nbsp;{{cas_nihss_totalscore}}</span>
              </div>

            </p-panel>
          </div>
            <div [ngClass]="{'disabled':isReadonlyUnCancleCase}" class="formgrid grid">
              <div class="col-12 md:col-12 lg:col-6 mt-3" [ngClass]="{'disabled':isReadonly}">
                <label for="CaseType"><b>Case Type:</b></label>
                <span class="p-input-icon-right w-full">
                  <input id="LastName" name="LastName" type="text" class="inputfield pointer-event" pInputText
                    formControlName="caseTypeName">
                </span>
              </div>
              <div class="col-12 md:col-12 lg:col-6 mt-3" [ngClass]="{'disabled':isReadonly}">
                <label for="Reviewer"><b>Reviewer(S):</b></label>
                <span class="p-input-icon-right w-full">
                  <p-multiSelect class="w-full" [options]="listReviewersDropdown" placeholder="Select Reviewer"
                    defaultLabel="Select Review" optionLabel="FullName" display="chip" optionValue="Id"
                    formControlName="cas_response_reviewer">
                  </p-multiSelect>
                </span>
              </div>
              <div class="col-12 md:col-12 lg:col-6 mt-2" [ngClass]="{'disabled':isReadonly}" id="Director_to_Review">
                <label for="MedicalDirectortoReview" style="color: #800020;"><b
                    [ngStyle]="Director_to_Review_bool ? {'border':'1px solid'} : {'':''}">Medical Director to
                    Review:</b></label>
                <span class="p-input-icon-right w-full">
                  <p-radioButton id="Yes" [value]=1 formControlName="cas_response_MD_to_review"
                    (click)="MedicalDirectortoReview('Yes');">
                  </p-radioButton>
                  <label class="-mb-3 ml-1 mr-3" for="Yes">Yes</label>
                  <p-radioButton id="No" [value]=2 formControlName="cas_response_MD_to_review"
                    (click)="MedicalDirectortoReview('No');">
                  </p-radioButton>
                  <label class="-mb-3 ml-1" for="No">No</label>
                </span>
              </div>
              <div class="col-12 md:col-12 lg:col-6" *ngIf="casResponseMDToreviewBool" [ngClass]="{'disabled':isReadonly}">
                <label for="cas_response_medical_director_reviewer"><b>MD Assignment DateTime:</b></label>
                <div class="flex align-items-center">
                  <span class="p-input-icon-right">
                    <i (click)="setDateAndTimeDynamically('i','cas_response_MD_assignment_datetime','');"
                      class="pi pi-clock" style="cursor: pointer;"></i>
                    <input formControlName="cas_response_MD_assignment_datetime" [readonly]="true" type="text" class="inputfield"
                      pInputText>
                  </span>
                  <span *ngIf=" MdDateEst">{{timeZone}}</span>
                </div>
              </div>
              <div class="col-12 md:col-12 lg:col-6 mt-2" [ngClass]="{'disabled':isReadonly}">
                <label for="cas_response_medical_director_reviewer"><b>Medical Director:</b></label>
                <span class="p-input-icon-right w-full">
                  <p-multiSelect class="w-full" [options]="directorListDropdown" placeholder="Select Medical Director"
                    defaultLabel="Select Medical Director" optionLabel="FullName" display="chip" optionValue="Id"
                    formControlName="cas_response_medical_director_reviewer">
                  </p-multiSelect>
                </span>
              </div>
            </div>
            <!--Correspondence CARDS -->
            <p-card class="card">
              <form [formGroup]="CorrespondenceForm">
                <p-button *ngIf="!isReadonly" [ngClass]="{'disabled':isReadonlyUnCancleCase}" icon="pi pi-plus"
                  label="Add Record" (click)="addCorrespondenceRecord()"
                  class="ml-2 p-button-primary btn-padding-custom flex add-recordbtn mb-2" type="button">
                </p-button>
                <table class="table table-bordered" formArrayName="correspondenceRecord">
                  <tr class="table-header">
                    <th class="table-header-th">Date And Time Of Contact</th>
                    <th class="table-header-th">Type Of Correspondence</th>
                    <th class="table-header-th">Comments</th>
                    <th class="table-header-th">Action</th>
                  </tr>
                  <tbody class="type-coresspond">
                    <tr *ngFor="let quantity of correspondenceRecord().controls; let i=index" [formGroupName]="i">
                      <td [ngClass]="{'disabled':isReadonly}">
                        <span class="p-input-icon-right">
                          <i (click)="setDateAndTimeDynamically(i,'Correspondence','');" class="pi pi-clock"
                            style="cursor: pointer;"></i>
                          <input formControlName="dateAndTimeOfContact" [readonly]="true" id="LastName" name="LastName" type="text"
                            (keypress)="false" class="inputfield" pInputText>
                        </span>
                      </td>
                      <td [ngClass]="{'disabled':isReadonly}">
                        <p-dropdown [options]="typeOfCorrespondence" formControlName="typeOfCorrespondence"
                          class="form-control" placeholder="--Select--" optionLabel="name" optionValue="value">
                        </p-dropdown>
                      </td>
                      <td>
                        <textarea formControlName="comments" rows="1" cols="30" [readonly]="isReadonly" pInputTextarea></textarea>
                      </td>
                      <td>
                        <p-button label="Remove"
                          [ngStyle]=" isReadonly?{'pointer-events': 'none'} : {'pointer-events': 'all'}"
                          (click)="removeCorrespondenceRecord(i)" [disabled]=" isReadonly"
                          class="ml-2 p-button-primary btn-padding-custom" type="button"></p-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </form>
            </p-card>
            <!-- Medical Director review completed CARD -->
            <p-card [ngClass]="{'disabled':isReadonly}" class="card">
              <div class="field-checkbox " [style.margin-bottom]="!isReadonly? '-2rem' : '0rem'">
                <p-checkbox [(ngModel)]="reviewCompletedBool" [ngModelOptions]="{standalone: true}" [binary]="true"
                  inputId="binary"></p-checkbox>
                <label class="font-bold" for="binary">Medical Director review completed</label>
              </div>
              <form [formGroup]="MedicalDirectorForm">
                <p-button *ngIf="!isReadonly"
                  [ngStyle]="reviewCompletedBool?{'pointer-events': 'none'} : {'pointer-events': 'all'}"
                  icon="pi pi-plus" label="Add Record" (click)="addMedicalDirectorReview()"
                  [disabled]="reviewCompletedBool"
                  class="ml-2 p-button-primary btn-padding-custom flex add-recordbtn mb-2" type="button">
                </p-button>
                <table class="table table-bordered" formArrayName="MedicalDirectorReview">
                  <tr class="table-header">
                    <th class="table-header-th">Medical Director Review Initiated</th>
                    <th class="table-header-th">Medical Director Review Completed</th>
                    <th class="table-header-th">Action</th>
                  </tr>
                  <tr *ngFor="let quantity of MedicalDirectorReview().controls; let i=index" [formGroupName]="i">
                    <td>
                      <span class="p-input-icon-right">
                        <i (click)="setDateAndTimeDynamically(i,'Medical Director','medicalDirectorReviewinitiated');"
                          class="pi pi-clock" style="cursor: pointer;"></i>
                        <input formControlName="medicalDirectorReviewinitiated" [readonly]="true" id="medicalDirectorReviewinitiated"
                          name="LastName" type="text" (keypress)="false" class="inputfield" pInputText>
                      </span>
                    </td>
                    <td>
                      <span class="p-input-icon-right">
                        <i (click)="setDateAndTimeDynamically(i,'Medical Director','medicalDirectorReviewCompleted');"
                          class="pi pi-clock" style="cursor: pointer;"></i>
                        <input formControlName="medicalDirectorReviewCompleted" [readonly]="true" id="medicalDirectorReviewCompleted"
                          name="LastName" type="text" (keypress)="false" class="inputfield" pInputText>
                      </span>
                    </td>
                    <td>
                      <p-button label="Remove"
                        [ngStyle]=" isReadonly?{'pointer-events': 'none'} : {'pointer-events': 'all'}"
                        (click)="removeMedicalDirectorReview(i)" [disabled]=" isReadonly"
                        class="ml-2 p-button-primary btn-padding-custom" type="button"></p-button>
                    </td>
                  </tr>
                </table>
              </form>
            </p-card>
            <div [ngClass]="{'disabled':isReadonlyUnCancleCase}" class="grid">

              <div *ngIf="!roleForFacility"class="col-12 md:col-12 lg:col-6">
                <div>
                  <label for="MedicalDirectorAssessment"><b>Medical Director Assessment:</b></label>
                  <span class="p-input-icon-right w-full">
                    <textarea formControlName="cas_response_case_research" rows="2" cols="30" [readonly]="isReadonly" pInputTextarea></textarea>
                  </span>
                </div>
                <div class="facility-talk">
                  <label for="FacilityCommunication"><b>Facility Communication:</b></label>
                  <span class="p-input-icon-right w-full">
                    <textarea formControlName="cas_review_facility_communication" rows="2" cols="30" [readonly]="isReadonly"
                      pInputTextarea></textarea>
                  </span>
                </div>
              </div>
              <div class="col-12 md:col-12 lg:col-6">
                <label for="QPSAssessment"><b>QPS Assessment:</b></label>
                <span class="p-input-icon-right w-full">
                  <textarea formControlName="cas_response_case_qps_assessment" rows="6" cols="30" [readonly]="isReadonly"
                    pInputTextarea></textarea>
                </span>
              </div>

              <div class="col-12 md:col-12 lg:col-12">
                <label *ngIf="isAccessInternalNotes && !roleForFacility" (click)="internalNotesDialog();" for="IN"
                  class="popUp-Text"><b>IN</b></label>
              </div>
              <div class="col-12 md:col-12 lg:col-6" [ngClass]="{'disabled':isReadonly}">
                <label for="FacilityRequestedReview"><b>Facility Requested Review:</b></label>
                <span class="p-input-icon-right w-full">
                  <p-radioButton id="Yes" [value]=1 formControlName="cas_response_case_facility_request_reviewed">
                  </p-radioButton>
                  <label class="-mb-3 ml-1 mr-3" for="IsEEG">Yes</label>
                  <p-radioButton id="No" [value]=2 formControlName="cas_response_case_facility_request_reviewed">
                  </p-radioButton>
                  <label class="-mb-3 ml-1 mr-3" for="radio2">No</label>
                  <p-radioButton id="No" [value]=3 formControlName="cas_response_case_facility_request_reviewed">
                  </p-radioButton>
                  <label class="-mb-3 ml-1" for="radio2">N/A</label>
                </span>
              </div>

              <div class="col-12 md:col-12 lg:col-6" [ngClass]="{'disabled':isReadonly}">
                <label for="PeerReviewRequested"><b>Peer Review Requested:</b></label>
                <span class="p-input-icon-right w-full">
                  <p-radioButton id="Yes" (click)="PeerReviewRequested('Yes');" [value]=1
                    formControlName="cas_response_peer_review">
                  </p-radioButton>
                  <label class="-mb-3 ml-1 mr-3" for="IsEEG">Yes</label>
                  <p-radioButton id="No" (click)="PeerReviewRequested('No');" [value]=2
                    formControlName="cas_response_peer_review">
                  </p-radioButton>
                  <label class="-mb-3 ml-1 " for="radio2">No</label>
                </span>
              </div>

              <ng-container *ngIf="PeerReviewRequestedBool">
                <div class="col-12 md:col-12 lg:col-6" [ngClass]="{'disabled':isReadonly}">
                  <label for="PeerReviewRequested"><b>Peer Review Physician:</b></label>
                  <p-multiSelect class="w-full" [options]="peerReviewPhysicionDropdown"
                    placeholder="Select Peer Review Physician" defaultLabel="Select Peer Review Physician"
                    optionLabel="FullName" display="chip" optionValue="Id"
                    formControlName="cas_response_peer_review_Physicians">
                  </p-multiSelect>
                </div>

                <div class="col-12 md:col-12 lg:col-6" [ngClass]="{'disabled':isReadonly}">
                  <label for="PeerReviewRequested"><b>Peer Review Assignment:</b></label>
                  <div class="flex align-items-center">
                    <span class="p-input-icon-right">
                      <i (click)="setDateAndTimeDynamically('','cas_response_peer_review_assignment_stamp','');"
                        class="pi pi-clock" style="cursor: pointer;"></i>
                      <input formControlName="cas_response_peer_review_assignment_stamp" [readonly]="true" type="text" class="inputfield"
                        pInputText>
                    </span>
                    <span *ngIf="PreeAssignmentEst">{{timeZone}}</span>
                  </div>
                  
                </div>
                <div class="col-12 md:col-12 lg:col-6" [ngClass]="{'disabled':isReadonly}">
                  <label for="PeerReviewRequested"><b>Peer Review Initiated:</b></label>
                  <div class="flex align-items-center">
                  <span class="p-input-icon-right peer-initiat">
                    <i (click)="setDateAndTimeDynamically('i','cas_response_peer_review_initiated_stamp','');"
                      class="pi pi-clock" style="cursor: pointer;"></i>
                    <input formControlName="cas_response_peer_review_initiated_stamp" [readonly]="true" type="text" class="inputfield"
                      pInputText>
                  </span>
                  <span *ngIf="PreeInitiatedEst">{{timeZone}}</span>
                  </div>
                </div>

                <div class="col-12 md:col-12 lg:col-6" [ngClass]="{'disabled':isReadonly}">
                  <label for="PeerReviewRequested"><b>Peer Review Completed:</b></label>
                  <div class="flex align-items-center">
                  <span class="p-input-icon-right">
                    <i (click)="setDateAndTimeDynamically('i','cas_response_peer_review_completed_stamp','');"
                      class="pi pi-clock" style="cursor: pointer;"></i>
                    <input formControlName="cas_response_peer_review_completed_stamp" [readonly]="true" type="text" class="inputfield"
                      pInputText>
                  </span>
                  <span *ngIf="PreecompletedEst">{{timeZone}}</span>
                  </div>
                </div>

              </ng-container>
              <div class="col-12 md:col-12 lg:col-6">
                <label for="QPSReviewCompleted"><b>QPS Review Completed:</b></label>
              </div>
              <div class="col-12 md:col-12 lg:col-6" [ngClass]="{'disabled':isReadonly}">
                <span class="p-input-icon-right w-full">
                  <p-checkbox (onChange)="ToggleQPSReviewField();" formControlName="cas_response_case_qps_reviewed"
                    [binary]="true" inputId="binary"></p-checkbox>
                </span>
              </div>
              <div class="col-12 md:col-12 lg:col-6" [ngClass]="{'disabled':isReadonly}">
                <div class="flex align-items-center">
                  <span class="flex align-items-center p-input-icon-right" *ngIf="QPSReviewField">
                    <i (click)="setDateAndTimeDynamically('i','cas_review_qps_reviewed_completed','');"
                      class="Est-clock  pi pi-clock" style="cursor: pointer;"></i>
                    <input formControlName="cas_review_qps_reviewed_completed" [readonly]="true" id="LastName" name="LastName" type="text"
                      class="inputfield" pInputText>
                    </span>
                    <span *ngIf="QpsCompletedEst && QPSReviewField">{{timeZone}}</span>
                </div>                                  
              </div>
              <div class="col-12 md:col-12 lg:col-6"></div>
                <div class="col-12 md:col-12 lg:col-6">
                  <label for="QPSReviewCompleted"><b>Case Summary Sent to Facility:</b></label>
                </div>
                <div class="col-12 md:col-12 lg:col-6" [ngClass]="{'disabled':isReadonly}">
                  <span class="p-input-icon-right w-full">
                    <p-checkbox formControlName="cas_case_summary_sent_to_facility" [binary]="true" inputId="binary">
                    </p-checkbox>
                  </span>
                </div>
            
              

            </div>
            <!--Operations Review Panel -->
            <p-panel *ngIf="!roleForFacility"header="Operations Review" [toggleable]="true" [collapsed]=false >
              <div [ngClass]="{'disabled':isReadonlyUnCancleCase}" class="formgrid grid">
                <div class="col-6 md:col-6 lg:col-6">
                  <label for="cas_operations_review_completed"><b>Operations Review Completed:</b></label>
                </div>
                <div class="col-6 md:col-6 lg:col-6" [ngClass]="{'disabled':isReadonly}">
                  <span class="p-input-icon-right w-full">
                    <p-checkbox (onChange)="ToggleOperationsReview()" formControlName="cas_operations_review_completed"
                      [binary]="true" inputId="binary"></p-checkbox>
                  </span>
                </div>
                <div class="col-12 md:col-12 lg:col-6 mt-2" [ngClass]="{'disabled':isReadonly}">
                  <div class="flex align-items-center">
                    <span class="p-input-icon-right" *ngIf="OperationsReview">
                      <i (click)="setDateAndTimeDynamically('i','cas_response_operations_review_completed','');"
                        class="Est-clock pi pi-clock" style="cursor: pointer;"></i>
                      <input formControlName="cas_response_operations_review_completed" [readonly]="true" id="LastName" name="LastName"
                        type="text" class="inputfield" pInputText>
                    </span>
                    <span *ngIf="OperationsCompletedEst && OperationsReview">{{timeZone}}</span>
                  </div>
                </div>
                <div class="col-12 md:col-12 lg:col-6 mt-2">
                  <label for="cas_operations_review"><b>Operations Review:</b></label>
                  <span class="p-input-icon-right w-full">
                    <textarea formControlName="cas_operations_review" rows="4" cols="20" [readonly]="isReadonly" pInputTextarea></textarea>
                  </span>
                </div>
              </div>
            </p-panel>
            <div class="grid" [ngClass]="{'disabled':isReadonly}">
              <div class="col-12 md:col-12 lg:col-6 mt-2">
                <label for="QPSAssigned"><b>QPS Assigned:</b></label>
                <span class="p-input-icon-right w-full">
                  <input id="disabled-input" name="QPSName" type="text" class="inputfield pointer-event" pInputText
                    formControlName="QPSName">
                </span>
              </div>
            </div>
          </div>

          <!-- circle diagram tree -->

          <div id="circleDiagramTree" [class]="mainRCADiagramFCRT ? 'col-6' : 'rcafish-responsive col-12 md:col-12 lg:col-12'">
            <div *ngIf="isTemplateBool" [class]="mainRCADiagramFCRT ? 'md:col-8 md:col-offset-3' : 'md:col-4 md:col-offset-4'" [id]="mainRCADiagramFCRT ? 'mainRCADiagramFCRT2' : 'mainRCADiagramFCRT'"
              >
              <div class="grid relative align-items-center">
                <div class="needle-first disableRCADiagram">
                  <p *ngIf="!before_circle_bool"><b style="font-size:11px !important;">Arrival
                      Time</b><br>({{arrival_time_before_circle}})
                  </p>
                  <!-- <img src="../../../../../../assets/images/Arrival Time.svg"> -->
                </div>
                <div class="rental-manager-progress-bar-container">
                  <div class="squre-imge disableRCADiagram">
                    <div class="circle-imge circle-1">
                      <div id="RCAFishBoneJSTreeforActivation"> </div>
                      <img [ngClass]="{ 'icons-border': ActivationTimeIntervalMetricBool && markActivation, 'disabled': isReadonly }"
                        (click)="showTreeDialog('Activation','top', true)" style="cursor: pointer"
                        pTooltip="Activation: RED  if > 10 minutes for Triage and SO during ED stay or inpatient,  and if >0 minutes for EMS workflow"
                        tooltipPosition="bottom" src="assets/images/svg-icons/activation-delay.png" width="65" height="65" />
                    </div>
                    <p [ngClass]="ActivationTimeIntervalMetricBool && markActivation ? 'redColorapply' : ''"><b>Activation</b>&nbsp;<b
                        *ngIf="TATimelineBool == false">({{activation_circle_time}})</b></p>
                  </div>
                  <div class="squre-imge disableRCADiagram">
                    <div class="circle-imge circle-2">
                      <div id="RCAFishBoneJSTreeforAssessment"> </div>
                      <img [ngClass]="{ 'icons-border': AssessmentTimeIntervalMetricBool && markAssesment, 'disabled': isReadonly }" 
                        (click)="showTreeDialog('Assessment Start Time','top', true)" style="cursor: pointer"
                        pTooltip="Assessment:  This is assessment time minus start time – (RED if more than 12 minutes)"
                        tooltipPosition="bottom" src="assets/images/svg-icons/assesment-start-time-delay.png" width="65" height="65" />
                    </div>
                    <p [ngClass]="AssessmentTimeIntervalMetricBool && markAssesment ? 'redColorapply' : ''"><b>Assessment <br />Start
                      </b>&nbsp;<b *ngIf="TATimelineBool == false">({{cas_assessment_time_est_for_circle}})</b></p>
                  </div>
                  <div class="squre-imge disableRCADiagram">
                    <div class="circle-imge circle-3">
                      <div id="RCAFishBoneJSTreeforTD"> </div>
                      <img [ngClass]="{ 'icons-border': ThrombolyticDecisionIntervalMetricBool && markThrombolytic, 'disabled': isReadonly }" 
                        (click)="showTreeDialog('Thrombolytic Decision','top', true)" style="cursor: pointer"
                        pTooltip="Thrombolytic decision: “Thrombolytic Medical Decision” minus the “Assessment Time” –  (RED if more than 10 minutes)"
                        tooltipPosition="bottom" src="assets/images/svg-icons/thrombolytic-decision-delay.png" width="65" height="65" />
                    </div>
                    <p [ngClass]="ThrombolyticDecisionIntervalMetricBool && markThrombolytic ? 'redColorapply' : ''"><b>Thrombolytic
                        <br />Decision</b>&nbsp;
                      <b *ngIf="TATimelineBool == false">({{thrombolytic_decision_time}})</b>
                  </div>
                  <div class="squre-imge disableRCADiagram" *ngIf="thrombolyticCandidateBool === true">
                    <div class="circle-imge circle-4">
                      <div id="RCAFishBoneJSTreeforTA"> </div>
                      <img [ngClass]="{ 'icons-border': ThrombolyticAdministrationIntervalMetricBool && markThrombolyticAdmin, 'disabled': isReadonly }"
                        (click)="showTreeDialog('Thrombolytic Administration','top', true)" style="cursor: pointer"
                        pTooltip="Thrombolytic Administration:  (“Needle Time” minus “Thrombolytic Medical Decision” –  (Red if more than 8 minutes)"
                        tooltipPosition="bottom" src="assets/images/svg-icons/thrombolytic-administration-delay.png" width="65" height="65" />
                    </div>
                    <p [ngClass]="ThrombolyticAdministrationIntervalMetricBool && markThrombolyticAdmin ? 'redColorapply' : ''"><b>Thrombolytic
                        <br />Administration
                      </b><b *ngIf="TATimelineBool == false">({{thrombolic_administration_circle_time}})</b></p>
                  </div>

                </div>
                <div class="needle-last disableRCADiagram">
                  <p *ngIf="!TATimelineBool" [ngClass]="ArrivalToNeedleTimeBoolean ? 'rapidi' : ''"><b style="font-size:11px !important;">
                    {{labelAfterCircle}}</b><br>({{time_after_circle}})</p>
                  <!-- <img src="../../../../../../assets/images/Needle Time.svg"> -->
                </div>
              </div>
            </div>
          </div>
          <!-- circle diagram tree -->
          <!-- ARRAY on countermeasures start-->
          <div *ngIf="counterMeasuresBool && isTemplateBool" class="md:col-12">
            <form class="counter-measure" [formGroup]="CounterMeasuresForm">
              <table class="table table-bordered" formArrayName="counterMeasuresRecord">
                <tr class="table-header">
                  <th class="table-header-th">Root Cause</th>
                  <th class="table-header-th">Countermeasure(S)</th>
                  <th class="table-header-th">Responsible Party</th>
                  <th class="table-header-th">Proposed Due Date</th>
                  <th class="table-header-th">Completed Date</th>
                  <th *ngIf="!isReadonly" class="table-header-th">Action</th>
                </tr>
                <tbody class="type-coresspond">
                  <tr [ngClass]="{'disabled':isReadonly}"
                    *ngFor="let quantity of countermeasureRecord().controls; let i=index" [formGroupName]="i">
                    <td>
                      <textarea formControlName="rootcausevalue" rows="3" cols="20" pInputTextarea></textarea>
                    </td>
                    <td>
                      <input type="text" class="inputfield " pInputText formControlName="propcountermsureval">
                    </td>
                    <td>
                      <input type="text" class="inputfield " pInputText formControlName="responsibleprtyval">
                    </td>
                    <td>
                      <p-calendar formControlName="fromDate" [showIcon]="true" [touchUI]="true" [readonlyInput]="true"
                        class="mr-2" [readonlyInput]="true"></p-calendar>
                    </td>
                    <td>
                      <p-calendar formControlName="toDate" [showIcon]="true" [touchUI]="true" [readonlyInput]="true"
                        class="mr-2" [readonlyInput]="true"></p-calendar>
                    </td>
                    <td *ngIf="!isReadonly">
                      <p-button label="Remove"
                        (click)="removeCountermeasureRecord(countermeasureRecord().controls[i].value.id,i,'removeCountermeasureRecord')"
                        class="ml-2 p-button-primary btn-padding-custom" type="button"></p-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </form>
          </div>
          <!-- ARRAY on countermeasures end-->

          <!-- Thrombolytic Administration Timeline -->
          <div *ngIf="tPACandidate && isTemplateBool && TATimelineBool" class="md:col-12"
            [ngClass]="{'disabled':isReadonly}">
            <div id="ThrombolyticAdministratedTimeline">
              <div *ngIf='workflowtypeForTimeline == "EMS" || workflowtypeForTimeline == "Triage/Walk-In"'>
                <div class="container" id="timelinecapture">
                  <div class="grid mt-5">
                    <div class="grid graph-timeline m-auto">
                      <strong>Thrombolytic Administration Timeline</strong>
                    </div>

                    <div class="col-12 md:col-12 lg:col-12 fisbone-responsive">
                      <div class="fishbone">

                        <div class="wrap-icon">
                          <img class="arrow-sign" src="../../../../../../assets/images/fishbone/arrow-siign1.svg"
                            alt="">
                          <br />
                        </div>

                        <div class="wrap-icon">
                          <i class="icon-box">
                            <span class="stroke-alert">Stroke Alert Start</span>
                          </i>
                          <br />
                        </div>

                        <div class="wrap-icon">
                          <i class="icon">
                            <span class="stroke-alert">0</span>
                          </i>
                          <div class="msg-view">
                            <img class="vector-down" src="../../../../../../assets/images/fishbone/vector-down.svg"
                              alt="">
                            <div *ngIf="!_isCas_metric_symptom_onset_during_ed_stay" class="speech2">
                              {{_arivaltime}} Arrived via {{workflowtypeForTimeline}}</div>

                          </div>
                          <div *ngIf="_isCas_metric_symptom_onset_during_ed_stay" class="lkw-time">{{_arivaltime}}
                            Symptom During ED-Stay</div>

                          <br />
                        </div>

                        <div *ngIf="_starttoarival <= 30 && _starttoarival >= 0" class="wrap-icon">
                          <i class="icon">
                            <span class="stroke-alert">{{_starttoarival}}</span>
                          </i>
                          <div class="msg-view">
                            <img class="vector1" src="../../../../../../assets/images/fishbone/vector.svg" alt="">
                            <div class="speech">
                              {{_startime}} Start-Time </div>
                          </div>
                        </div>
                        <br />

                        <div *ngIf="_starttoarival < 0" class="wrap-icon">
                          <i class="icon">
                            <span class="stroke-alert">{{_starttoarival}}</span>
                          </i>
                          <div class="msg-view">
                            <img class="vector1" src="../../../../../../assets/images/fishbone/vector.svg" alt="">
                            <div class="speech">
                              {{_startime}} PTA</div>
                          </div>
                          <br />
                        </div>
                        <div *ngIf="_starttoarival > 30 && _starttoarival <= 45" class="wrap-icon">
                          <i class="icon" [style.background]="yellows">
                            <span class="stroke-alert">{{_starttoarival}}</span>
                          </i>
                          <div class="msg-view">
                            <img class="vector1" src="../../../../../../assets/images/fishbone/vector.svg" alt="">
                            <div class="speech">
                              {{_startime}} PTA</div>
                          </div>
                          <br />
                        </div>
                        <div *ngIf="_starttoarival > 45" class="wrap-icon">
                          <i class="icon" [style.background]="reds">
                            <span class="stroke-alert">{{_starttoarival}}</span>
                          </i>
                          <div class="msg-view">
                            <img class="vector1" src="../../../../../../assets/images/fishbone/vector.svg" alt="">
                            <div class="speech">
                              {{_startime}} PTA</div>
                          </div>
                          <br />
                        </div>

                        <div *ngIf="_logintodoor <= 30" class="wrap-icon">
                          <i class="icon">
                            <span class="stroke-alert">{{_logintodoor}}</span>

                          </i>
                          <div class="msg-view">
                            <img class="vector-down" src="../../../../../../assets/images/fishbone/vector-down.svg"
                              alt="">
                            <div class="speech2">
                              {{_logintime}} Login-Time</div>
                          </div>
                          <br />
                        </div>
                        <div *ngIf="_logintodoor > 30 && _logintodoor <= 45" class="wrap-icon">
                          <i class="icon" [style.background]="yellows">
                            <span class="stroke-alert">{{_logintodoor}}</span>
                          </i>
                          <div class="msg-view">
                            <img class="vector-down" src="../../../../../../assets/images/fishbone/vector-down.svg"
                              alt="">
                            <div class="speech2">
                              {{_logintime}} Login-Time</div>
                          </div>
                          <br />
                        </div>

                        <div *ngIf="_logintodoor > 45" class="wrap-icon">
                          <i class="icon" [style.background]="reds">
                            <span class="stroke-alert">{{_logintodoor}}</span>
                          </i>
                          <div class="msg-view">
                            <img class="vector-down" src="../../../../../../assets/images/fishbone/vector-down.svg"
                              alt="">
                            <div class="speech2">
                              {{_logintime}} Login-Time</div>
                          </div>
                          <br />
                        </div>

                        <div *ngIf="_nihsstodoor <= 30" class="wrap-icon">
                          <i class="icon">
                            <span class="stroke-alert">{{_nihsstodoor}}</span>
                          </i>
                          <div class="msg-view">
                            <img class="vector1" src="../../../../../../assets/images/fishbone/vector.svg" alt="">
                            <div class="speech">
                              {{_nihsstime}} NIHSS-Time</div>
                          </div>
                          <br />
                        </div>
                        <div *ngIf="_nihsstodoor > 30 && _nihsstodoor <= 45" class="wrap-icon">
                          <i class="icon" [style.background]="yellows">
                            <span class="stroke-alert">{{_nihsstodoor}}</span>
                          </i>
                          <div class="msg-view">
                            <img class="vector1" src="../../../../../../assets/images/fishbone/vector.svg" alt="">
                            <div class="speech">
                              {{_nihsstime}} NIHSS-Time</div>
                          </div>
                          <br />
                        </div>
                        <div *ngIf="_nihsstodoor > 45" class="wrap-icon">
                          <i class="icon" [style.background]="reds">
                            <span class="stroke-alert">{{_nihsstodoor}}</span>
                          </i>
                          <div class="msg-view">
                            <img class="vector1" src="../../../../../../assets/images/fishbone/vector.svg" alt="">
                            <div class="speech">
                              {{_nihsstime}} NIHSS-Time</div>
                          </div>
                          <br />
                        </div>

                        <div *ngIf="_needletodoor <= 30" class="wrap-icon">
                          <i class="icon">
                            <span class="stroke-alert">{{_needletodoor}}</span>
                          </i>
                          <div class="msg-view">
                            <img class="vector-down" src="../../../../../../assets/images/fishbone/vector-down.svg"
                              alt="">
                            <div class="speech2">
                              {{_needletime}} Needle-Time </div>
                          </div>
                          <br />
                        </div>

                        <div *ngIf="_needletodoor > 30 && _needletodoor <= 45" class="wrap-icon">
                          <i class="icon" [style.background]="yellows">
                            <span class="stroke-alert">{{_needletodoor}}</span>
                          </i>
                          <div class="msg-view">
                            <img class="vector-down" src="../../../../../../assets/images/fishbone/vector-down.svg"
                              alt="">
                            <div class="speech2">
                              {{_needletime}} Needle-Time </div>
                          </div>
                          <br />
                        </div>
                        <div *ngIf="_needletodoor > 45" class="wrap-icon">
                          <i class="icon" [style.background]="reds">
                            <span class="stroke-alert">{{_needletodoor}}</span>
                          </i>
                          <div class="msg-view">
                            <img class="vector-down" src="../../../../../../assets/images/fishbone/vector-down.svg"
                              alt="">
                            <div class="speech2">
                              {{_needletime}} Needle-Time </div>
                          </div>
                          <br />
                        </div>

                        <div *ngIf="_doortoneedle <= 30" class="graph-items__circle_item text-center" id="restart">
                          <i class="icon-box2" [style.background]="greens">
                            <span class="stroke-alert"> {{dtnorstn}}:{{_doortoneedle}}</span>
                          </i>
                        </div>

                        <div *ngIf="_doortoneedle > 30 && _doortoneedle <= 45"
                          class="graph-items__circle_item text-center" id="restart">
                          <i class="icon-box2" [style.background]="yellows">
                            <span class="stroke-alert">{{dtnorstn}}:{{_doortoneedle}}</span>
                          </i>
                        </div>

                        <div *ngIf="_doortoneedle > 45" class="graph-items__circle_item text-center" id="restart">
                          <i class="icon-box2" [style.background]="reds">
                            <span class="stroke-alert">{{dtnorstn}}:{{_doortoneedle}}</span>
                          </i>
                        </div>

                        <div class="wrap-icon">
                          <img class="arrow-sign" src="../../../../../../assets/images/fishbone/arrow-sign2.svg" alt="">
                          <br />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                *ngIf='workflowtypeForTimeline == "Inpatient" || workflowtypeForTimeline == "Symptom Onset During ED Stay"'>
                <div class="container" id="timelinecapture">
                  <div class="grid graph-timeline">
                    <strong>Thrombolytic Administration Timeline</strong>
                  </div>

                  <div class="col-12 md:col-12 lg:col-12 fisbone-responsive">
                    <div class="fishbone">

                      <div class="wrap-icon">
                        <img class="arrow-sign" src="../../../../../../assets/images/fishbone/arrow-siign1.svg" alt="">
                        <br />
                      </div>

                      <div class="wrap-icon">
                        <i class="icon-box">
                          <span class="stroke-alert">Stroke Alert Start</span>
                        </i>
                        <br />
                      </div>

                      <div class="wrap-icon">
                        <i class="icon">
                          <span class="stroke-alert">0</span>
                        </i>
                        <div class="msg-view">
                          <img class="vector-down" src="../../../../../../assets/images/fishbone/vector-down.svg"
                            alt="">
                          <div class="speech2">
                            {{_lastknownwelltime}}
                            {{labeldiagramstime}} {{workflowlabel}} </div>
                        </div>
                        <br />
                      </div>

                      <div *ngIf="knownweltimetostarttime < 0" class="wrap-icon">
                        <i class="icon">
                          <span class="stroke-alert">{{knownweltimetostarttime}}</span>
                        </i>
                        <div class="msg-view">
                          <img class="vector1" src="../../../../../../assets/images/fishbone/vector.svg" alt="">
                          <div class="speech">
                            {{_startime}} PTA </div>
                        </div>
                        <br />
                      </div>
                      <div *ngIf="knownweltimetostarttime >= 0 && knownweltimetostarttime <= 30" class="wrap-icon">
                        <i class="icon">
                          <span class="stroke-alert">{{knownweltimetostarttime}}</span>
                        </i>
                        <div class="msg-view">
                          <img class="vector1" src="../../../../../../assets/images/fishbone/vector.svg" alt="">
                          <div class="speech">
                            {{_startime}} Start-Time</div>
                        </div>
                        <br />
                      </div>
                      <div *ngIf="knownweltimetostarttime > 30 && knownweltimetostarttime <= 45" class="wrap-icon">
                        <i class="icon" [style.background]="yellows">
                          <span class="stroke-alert">{{knownweltimetostarttime}}</span>
                        </i>
                        <div class="msg-view">
                          <img class="vector1" src="../../../../../../assets/images/fishbone/vector.svg" alt="">
                          <div class="speech">
                            {{_startime}} Start-Time</div>
                        </div>
                        <br />
                      </div>
                      <div *ngIf="knownweltimetostarttime > 45" class="wrap-icon">
                        <i class="icon" [style.background]="reds">
                          <span class="stroke-alert">{{knownweltimetostarttime}}</span>
                        </i>
                        <div class="msg-view">
                          <img class="vector1" src="../../../../../../assets/images/fishbone/vector.svg" alt="">
                          <div class="speech">
                            {{_startime}} Start-Time</div>
                        </div>
                        <br />
                      </div>

                      <div *ngIf="knownweltimetologintime <= 30" class="wrap-icon">
                        <i class="icon">
                          <span class="stroke-alert">{{knownweltimetologintime}}</span>
                        </i>
                        <div class="msg-view">
                          <img class="vector-down" src="../../../../../../assets/images/fishbone/vector-down.svg"
                            alt="">
                          <div class="speech2">
                            {{_logintime}} Login-Time </div>
                        </div>
                        <br />
                      </div>
                      <div *ngIf="knownweltimetologintime > 30 && knownweltimetologintime <= 45" class="wrap-icon">
                        <i class="icon" [style.background]="yellows">
                          <span class="stroke-alert">{{knownweltimetologintime}}</span>
                        </i>
                        <div class="msg-view">
                          <img class="vector-down" src="../../../../../../assets/images/fishbone/vector-down.svg"
                            alt="">
                          <div class="speech2">
                            {{_logintime}} Login-Time</div>
                        </div>
                        <br />
                      </div>
                      <div *ngIf="knownweltimetologintime > 45" class="wrap-icon">
                        <i class="icon" [style.background]="reds">
                          <span class="stroke-alert">{{knownweltimetologintime}}</span>
                        </i>
                        <div class="msg-view">
                          <img class="vector-down" src="../../../../../../assets/images/fishbone/vector-down.svg"
                            alt="">
                          <div class="speech2">
                            {{_logintime}} Login-Time</div>
                        </div>
                        <br />
                      </div>

                      <div *ngIf="knownweltimetonihss <= 30" class="wrap-icon">
                        <i class="icon">
                          <span class="stroke-alert">{{knownweltimetonihss}}</span>
                        </i>
                        <div class="msg-view">
                          <img class="vector1" src="../../../../../../assets/images/fishbone/vector.svg" alt="">
                          <div class="speech">
                            {{_nihsstime}} NIHSS-Time</div>
                        </div>
                        <br />
                      </div>
                      <div *ngIf="knownweltimetonihss > 30 && knownweltimetonihss <= 45" class="wrap-icon">
                        <i class="icon" [style.background]="yellows">
                          <span class="stroke-alert">{{knownweltimetonihss}}</span>
                        </i>
                        <div class="msg-view">
                          <img class="vector1" src="../../../../../../assets/images/fishbone/vector.svg" alt="">
                          <div class="speech">
                            {{_nihsstime}} NIHSS-Time</div>
                        </div>
                        <br />
                      </div>
                      <div *ngIf="knownweltimetonihss > 45" class="wrap-icon">
                        <i class="icon" [style.background]="reds">
                          <span class="stroke-alert">{{knownweltimetonihss}}</span>
                        </i>
                        <div class="msg-view">
                          <img class="vector1" src="../../../../../../assets/images/fishbone/vector.svg" alt="">
                          <div class="speech">
                            {{_nihsstime}} NIHSS-Time</div>
                        </div>
                        <br />
                      </div>

                      <div *ngIf="knownweltimetoneedle <= 30" class="wrap-icon">
                        <i class="icon">
                          <span class="stroke-alert">{{knownweltimetoneedle}}</span>
                        </i>
                        <div class="msg-view">
                          <img class="vector-down" src="../../../../../../assets/images/fishbone/vector-down.svg"
                            alt="">
                          <div class="speech2">
                            {{_needletime}} Needle-Time </div>
                        </div>
                        <br />
                      </div>
                      <div *ngIf="knownweltimetoneedle > 30 && knownweltimetoneedle <= 45" class="wrap-icon">
                        <i class="icon" [style.background]="yellows">
                          <span class="stroke-alert">{{knownweltimetoneedle}}</span>
                        </i>
                        <div class="msg-view">
                          <img class="vector-down" src="../../../../../../assets/images/fishbone/vector-down.svg"
                            alt="">
                          <div class="speech2">
                            {{_needletime}} Needle-Time </div>
                        </div>
                        <br />
                      </div>
                      <div *ngIf="knownweltimetoneedle > 45" class="wrap-icon">
                        <i class="icon" [style.background]="reds">
                          <span class="stroke-alert">{{knownweltimetoneedle}}</span>
                        </i>
                        <div class="msg-view">
                          <img class="vector-down" src="../../../../../../assets/images/fishbone/vector-down.svg"
                            alt="">
                          <div class="speech2">
                            {{_needletime}} Needle-Time </div>
                        </div>
                        <br />
                      </div>

                      <div *ngIf="knownweltimetoneedle <= 30" class="graph-items__circle_item text-center" id="restart">
                        <i class="icon-box2" [style.background]="greens">
                          <span class="stroke-alert">{{labeldiagram}}:{{knownweltimetoneedle}}</span>
                        </i>
                      </div>

                      <div *ngIf="knownweltimetoneedle > 30 && knownweltimetoneedle <= 45"
                        class="graph-items__circle_item text-center" id="restart">
                        <i class="icon-box2" [style.background]="yellows">
                          <span class="stroke-alert"> {{labeldiagram}}:{{knownweltimetoneedle}}</span>
                        </i>
                      </div>

                      <div *ngIf="knownweltimetoneedle > 45" class="graph-items__circle_item text-center" id="restart">
                        <i class="icon-box2" [style.background]="reds">
                          <span class="stroke-alert"> {{labeldiagram}}:{{knownweltimetoneedle}}</span>
                        </i>
                      </div>

                      <div class="wrap-icon">
                        <img class="arrow-sign" src="../../../../../../assets/images/fishbone/arrow-sign2.svg" alt="">
                        <br />
                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!isReadonly" class="col-12 md:col-12 lg:col-12 text-right mt-5">
          <div class="formgrid flex m-2 justify-content-end">
            <button (click)="backTocasesList('backToCASESList');" type="button" class="btn-Cancel">Cancel</button>
            <p-button *ngIf="!showSaveBool" (click)="submit('save');" class="ml-2 p-button-primary btn-padding-custom"
              type="button" label="Save">
            </p-button>
            <p-button *ngIf="!showSaveBool" (click)="submit('save & close');"
              class="ml-2 p-button-primary btn-padding-custom" type="button" label="Save & Close">
            </p-button>
            <p-button *ngIf="!showSaveBool" (click)="GetEmaiRcaFacility('btn');"
              class="ml-2 p-button-primary btn-padding-custom" type="button" label="Shared Report History"
              [ngStyle]="sharedReportLoader ? {'pointer-events': 'none'} : {'pointer-events': 'all'}"
              [loading]="sharedReportLoader"></p-button>
            <p-button *ngIf="!showSaveBool && isTemplateBool" (click)="submit('');"
              class="ml-2 p-button-primary btn-padding-custom" type="button" label={{caseReviewTemplateButtonName}}>
            </p-button>
            <button *ngIf="showSaveBool" (click)="unCancelCase()" type="button" class="ml-2 btn-UnCancelCasee">Un-Cancel
              Case</button>
          </div>
        </div>

        <!-- Thrombolytic Administration Timeline -->
      </form>
    </div>
  </div>
</ng-container>


<!-- Case Assignment History Dialog Box -->
<p-dialog header="Case Assignment History" [draggable]="false" [modal]="true" [(visible)]="historyBool"
  [baseZIndex]="5000">
  <p-table class="case-assigpopup" [value]="HistoryData" styleClass="p-datatable-striped">
    <ng-template pTemplate="header" let-HistoryData>
      <tr>
        <th class="radius-left">Start Time</th>
        <th>Physician Name</th>
        <th>End Time Stamp</th>
        <th class="radius-right">Physician Status</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-HistoryData>
      <tr>
        <td>{{HistoryData.StartStampTime}}</td>
        <td>{{HistoryData.PhysicianName}}</td>
        <td>{{HistoryData.EndStampTime}}</td>
        <td>{{HistoryData.Status}}</td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>
<!-- Time First Login Attempt (TFLA) Dialog Box -->
<p-dialog header="Time First Login Attempt (TFLA)" [draggable]="false" [modal]="true" [(visible)]="TFLABool">
  <p>{{tfla}}</p>
  <div class="formgrid flex m-2">
    <div class="col-12 md:col-12 text-right mt-5">
      <p-button (click)="cancelTFLA();" type="button" class="p-button-secondary" label="Cancel"></p-button>
      <p-button (click)="okTFLA();" class="ml-2 p-button-secondary" type="button"
        label="&nbsp;&nbsp;OK&nbsp;&nbsp;">
      </p-button>
    </div>
  </div>
</p-dialog>
<!-- Internal Notes Dialog Box -->

<p-dialog header="Internal Notes" [draggable]="false" [modal]="true" [(visible)]="internalNotesBool"
  [breakpoints]="{'960px': '75vw'}" [style]="{width: '40vw'}">
  <textarea class="cases-textarea" (input)="CheckTextbox($event)" [ngClass]="{'disabled':isReadonly}"
    [(ngModel)]="internalNotes" rows="4" cols="30" pInputTextarea></textarea>
  <div class="formgrid flex m-2">
    <div class="col-12 md:col-12 text-right mt-5" *ngIf="!isReadonly">
      <button pButton type="button" (click)="cancelInternalNotes()" class=" btn-CancelNotes">
        <b>Cancel</b> </button>
      <p-button [disabled]="internalNotesSaveBool"
        [ngStyle]="(internalNotesSaveBool) ? {'pointer-events': 'none'} : {'pointer-events': 'all'}"
        (click)="insertInternalNotes();" class="ml-2 p-button-secondary" type="button" label="Insert">
      </p-button>
    </div>
  </div>
</p-dialog>
<!-- Cancle Toast -->
<div class="backdrop" [ngClass]="{ 'show-backdrop': showToast }"></div>
  <p-toast [style]="{ width: '25vw' }" position="center" [modal]="true" key="c" (onClose)="onReject()">
    <ng-template let-message pTemplate="message">
      <div class="flex flex-column" style="flex: 1">
        <div class="text-center">
          <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
          <h4>{{message.summary}}</h4>
          <p>{{message.detail}}</p>
        </div>
        <div class="grid p-fluid">
          <div class="col-6">
            <p-button label="YES" class="ml-2 p-button-primary btn-padding-custom" (click)="onConfirm()" type="button"></p-button>
          </div>
          <div class="col-6">
            <p-button label="No" class="ml-2 p-button-secondary btn-padding-custom" (click)="onReject()" type="button"></p-button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-toast>
<!-- Tree Dialog Box -->
<p-dialog header="{{treeLable}}" [draggable]="false" [modal]="true" [position]="position" class="z-3"
  [(visible)]="treeSelectionBool" (onHide)="closeRCADiagramPopUp()" [style]="{width: '50vw'}">
  <span *ngIf="errorMessageBool" style="color: red;font-size: 13px;"><b>Uncheck secondary checkbox</b></span>
  <p-tree id="test" [value]="treeSelection" [filter]="true" scrollHeight="500px" [(selection)]="treeSelected"
    selectionMode="checkbox" (onNodeSelect)="nodeSelect($event)" (onNodeUnselect)="nodeUnselect($event)"
    [propagateSelectionUp]="false" [propagateSelectionDown]="false"></p-tree>
  <div class="formgrid flex m-2" *ngIf="!TATimelineBool">
    <div class="col-12 md:col-12 lg:col-12 text-right mt-5">
      <p-button class="ml-2 p-button-primary btn-padding-custom" type="button" label="Countermeasure(s)"
        (click)="showCounterMeasures()">
      </p-button>
    </div>
  </div>
</p-dialog>
<!-- Case Review Template Dialog Box -->

<p-dialog header="Case Review Template" [draggable]="false" [modal]="true" [(visible)]="generateTemplatebool"
  [breakpoints]="{'960px': '75vw'}" [style]="{width: '70vw', height:'35vw'}">
  <div class="fixed transform z-1" *ngIf="showProgressSpinner">
    <app-custom-spinner></app-custom-spinner>
  </div>
  <!-- <ckeditor id="editor" name="editor" #editor [(ngModel)]="caseReviewTemplate" debounce="500" [editor]="editorr">
  </ckeditor> -->
  <angular-editor [placeholder]="'Enter text here...'" [(ngModel)]="caseReviewTemplate" [config]="editorConfig"></angular-editor>

  <ng-template pTemplate="footer">
  <div class="formgrid flex m-2">
    <div class="col-12 md:col-12 lg:col-3 text-left">
      <button pButton type="button" (click)="cancleTemplate()" class=" btn-UnCancelCase">
        <i class="pi pi-times"></i>&nbsp; <b>Cancel</b> </button>

    </div>
    <div class="col-12 md:col-12 lg:col-9 text-right">
      <p-button (click)="GetFacilityContact(event)" class="ml-2 p-button-primary btn-padding-custom" type="button"
        label="Share" [loading]="sharebtnLoader"></p-button>
      <p-button (click)="saveTemplate();" class="ml-2 p-button-primary btn-padding-custom" type="button" label="Save">
      </p-button>
      <p-button (click)="saveTemplate();  generateTemplatebool = false" class="ml-2 p-button-primary btn-padding-custom"
        type="button" label="Save & Close"></p-button>
      <p-button class="ml-2 p-button-primary btn-padding-custom" type="button"
        (click)="exportToWordCaseReviewTemplate()" label="Export Word"></p-button>

    </div>
  </div>
</ng-template>
</p-dialog>


<p-dialog id="advancedsr" [(visible)]="advanceSearchModal" [draggable]="false" [modal]="true" [style]="{width: '35vw'}"
  [breakpoints]="{'960px': '75vw'}">
  <ng-template pTemplate="header">
    <span class="flex align-items-center">
      <img class="advancedimg" src="../../../../../../assets/images/advance-search-icon.png">
      <strong class="text-2xl ml-1">Advanced Search</strong>
    </span>
  </ng-template>
  <form [formGroup]="advanceFormSearch">
    <div class="grid p-fluid mt-3">
      <div class="col-12 md:col-12 lg:col-12col-12 md:col-12 lg:col-12">
        <label for="caseNumber"><b>Case Number:</b></label>
        <input type="text" formControlName="cas_case_number" pInputText>
      </div>
      <!-- <div class="col-12 md:col-12 lg:col-12col-12 md:col-12 lg:col-12">
        <label for="caseNumber"><b>Case Types:</b></label>
        <p-multiSelect [options]="caseTypeOptions" formControlName="cas_case_type" optionLabel="Text"
          class="form-control" placeholder="--Select Case Type--" [filter]="true" filterBy="Text" optionValue="Value"
          display="chip"></p-multiSelect>
      </div> -->
      <div class="col-12 md:col-12 lg:col-12col-12 md:col-12 lg:col-12">
        <label for="patientName"><b>Patient Name:</b></label>
        <input name="cas_patient" type="text" pInputText formControlName="cas_patient">
      </div>
      <div class="col-12 md:col-12 lg:col-12col-12 md:col-12 lg:col-12">
        <label for="date"><b>Date:</b></label>
        <p-calendar [showIcon]="true" formControlName="cas_advance_date" inputId="icon"></p-calendar>
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <label for="caseNumber"><b>Follow Up:</b></label>
        <span class="p-input-icon-right w-full mt-1" id="follow_up">
          <p-multiSelect [options]="folowUpList" formControlName="folowUp" filterBy="name" display="chip"
            class="form-control" placeholder="--Select Follow Up--" optionLabel="name" optionValue="value">
          </p-multiSelect>
        </span>
        <!-- <input type="text" pInputText> -->
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <label for="patientName"><b>Patient Identification Number:</b></label>
        <input name="cas_patient" type="text" pInputText formControlName="CASEIdentificatinNumber">
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <label for="caseNumber"><b>Physician:</b></label>
        <span class="p-input-icon-right w-full">
          <p-multiSelect [options]="physicionList" formControlName="selectedPhysicion" optionLabel="Name"
            class="form-control" placeholder="--Select Physician--" [filter]="true" filterBy="Name" optionValue="Id"
            display="chip" (onClick)="GetFacilityPhysicion()"></p-multiSelect>
        </span>
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <label for="caseNumber"><b>eAlert:</b></label>
        <p-dropdown [options]="eAlertOptions" formControlName="cas_eAlert" class="form-control"
          placeholder="--Select eAlert--" optionLabel="Text" optionValue="Value">
        </p-dropdown>
      </div>

      <div class="col-12 md:col-12 lg:col-12">
        <label for="caseNumber"><b>Workflow Type:</b></label>
        <p-multiSelect [options]="selectWorkFlowTypeOptions" formControlName="work_flow_type" class="form-control"
          placeholder="--Select Workflow Type--" optionValue="Value" optionLabel="Text" filterBy="Text" display="chip">
        </p-multiSelect>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button pButton type="button" (click)="advanceSearchModal=false" class=" btn-UnCancelCase">
      <i class="pi pi-times"></i>&nbsp; <b>Cancel</b> </button>
    <p-button type="button" icon="pi pi-search" label="Search" [loading]="advanceSearchLoader"
      (click)="getAllCases('advance', true)" styleClass="p-button-text"></p-button>
  </ng-template>

</p-dialog>

<p-dialog header="Monthly Report" [(visible)]="displayBasic2" [modal]="true" [style]="{width: '70vw'}"
  [draggable]="false" [resizable]="false">
  <p-table *ngIf="!noRecordFoundBool" #dt [value]="facilityMailData" [rows]="take" styleClass="p-datatable-striped p-datatable-gridlines"
    [paginator]="true" sortMode="multiple" [lazy]="true" (onLazyLoad)="loadfacilityMailData($event)"
    responsiveLayout="scroll" [rowHover]="true" dataKey="Id" [totalRecords]="totalRecords" [columns]="cols"
    [resizableColumns]="true" columnResizeMode="expand"
    styleClass="p-datatable-striped p-datatable-gridlines overflow-x-auto"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [resetPageOnSort]="false"
    [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25,50,totalRecords]" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header" let-facilityMailData>
      <tr>
        <th>Email</th>
        <th>Sent Date</th>
        <th style="width:15%">Attachment</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-facilityMailData let-rowIndex="rowIndex">
      <tr>
        <td>{{facilityMailData.qitsd_email}}</td>
        <td>{{facilityMailData.qitsd_created_by_date}}</td>
        <td style="width:15%">
          <p-button label="Get PDF" (click)="getPdf(facilityMailData);" id="getPdf"></p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <!-- <ng-template > -->
  <h3 class="text-center" *ngIf="noRecordFoundBool"><b>No Record Found</b></h3>
  <!-- </ng-template> -->
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-check" (click)="displayBasic2=false;take=10;skip=0;selectedOptionText=false" label="Ok"
      styleClass="p-button-text"></p-button>
  </ng-template>
</p-dialog>


<!-- Click Share btn to show dialog to send email -->
<p-dialog header="Share Case Review Template - {{editCaseData.cas_case_number}}" [(visible)]="displayModal"
  [modal]="true" [draggable]="false" [resizable]="false">
  <p-toast position="top-right" key="emailErr"></p-toast>
  <p-table [value]="shareImprove" [scrollable]="true" scrollHeight="400px" [resizableColumns]="true"
    columnResizeMode="expand" styleClass="p-datatable-gridlines">
    <ng-template pTemplate="header" let-shareImprove>
      <tr>
        <th style="min-width:50px">
          <p-checkbox [(ngModel)]="masterSelected" class="ml-1" name="list_name" value="m1" [binary]="true"
            (onChange)="checkUncheckAll()"></p-checkbox>
        </th>
        <th style="min-width:200px">Name</th>
        <th style="min-width:250px">Email</th>
        <th style="min-width:150px">Phone Number</th>
        <th style="min-width:250px">Facility Role</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-shareImprove>
      <tr class="p-selectable-row">
        <td style="min-width:50px">
          <p-checkbox [(ngModel)]="shareImprove.isSelected" name="list_name" value="{{shareImprove.id}}" [binary]="true"
            (onChange)="isAllSelected()"></p-checkbox>
        </td>
        <td pTooltip="{{shareImprove.name}}" tooltipPosition="top" style="min-width:200px">{{shareImprove.name}}</td>
        <td pTooltip="{{shareImprove.email}}" tooltipPosition="top" style="min-width:250px">{{shareImprove.email}}</td>
        <td pTooltip="{{shareImprove.phone}}" tooltipPosition="top" style="min-width:150px">{{shareImprove.phone}}</td>
        <td pTooltip="{{shareImprove.label}}" tooltipPosition="top" style="min-width:250px">{{shareImprove.label}}</td>
      </tr>
    </ng-template>
  </p-table>

  <ng-template pTemplate="footer">
    <button pButton type="button" (click)="displayModal=false" class=" btn-UnCancelCase">
      <i class="pi pi-times"></i>&nbsp; <b>Cancel</b> </button>
    <p-button label="Send Email" styleClass="p-button-text" (click)="SendEmail()" [loading]="sendEmailLoader">
    </p-button>
  </ng-template>
</p-dialog>
